module.exports = __webpack_public_path__ + "img/poklon.09e225d8.png";